import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { cloneElement } from 'react';
import { reduxForm } from 'redux-form';
import { propFunc, propStr, propChildren, ReduxFormProps, } from '../../../../helpers/custom-prop-types';
import { compose } from '../../../../helpers/recompose';
import ModalHoc from '../../Modal/ModalHoc';
import SlideSearchRegistrationModalRight from './Parts/SlideSearchRegistrationModalRight';
/**
 * PROFFIT SEARCHへの登録/トライアルの開始、もしくは氏名入力を行うモーダル
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
const SlideSearchRegistrationModal = (props) => {
    const { error, form, formComponent, handleSubmit, hideModal, modalState, submitting, } = props;
    return (_jsxs("div", Object.assign({ className: `slide_search_registration_modal fade_modal animated-opacity ${modalState}` }, { children: [_jsx("div", { className: 'bg', onClick: submitting ? undefined : hideModal, role: 'presentation' }), _jsx("div", Object.assign({ className: 'modal_box' }, { children: _jsxs("div", Object.assign({ className: 'modal_body' }, { children: [_jsx("div", Object.assign({ className: 'body_left' }, { children: cloneElement(formComponent, {
                                error,
                                form,
                                handleSubmit,
                                submitting,
                            }) })), _jsx("div", Object.assign({ className: 'body_right' }, { children: _jsx(SlideSearchRegistrationModalRight, {}) }))] })) }))] })));
};
SlideSearchRegistrationModal.propTypes = Object.assign({ form: propStr().isRequired, formComponent: propChildren().isRequired, hideModal: propFunc(), modalState: propStr().isRequired }, ReduxFormProps);
SlideSearchRegistrationModal.defaultProps = {
    hideModal: undefined,
};
const enhance = compose(ModalHoc, reduxForm({ form: 'SlideSearchRegistrationModal' }));
export default enhance(SlideSearchRegistrationModal);
